<template>
  <div
    style="text-align: center; padding: 15px 0"
    v-infinite-scroll="loadMore"
    :infinite-scroll-disabled="busy"
    :infinite-scroll-distance="distance"
    v-if="!busy"
  >
    <v-progress-circular
      indeterminate
      color="primary"
      class="bottom"
    />
  </div>
</template>
<script>
import infiniteScroll from "./directives";
export default {
  props: {
    distance: {
      default: 50,
    },
    disabled: {},
    pageBegin: {
      type: Number,
      default: 1,
    },
  },
  directives: { infiniteScroll },
  data() {
    return {
      page: 1,
      busy: false,
    };
  },
  watch: {
    disabled: {
      immediate: true,
      handler(val) {
        if (val) this.busy = true;
      },
    },
    pageBegin: {
      immediate: true,
      handler(val) {
        if (!isNaN(val)) {
          if (typeof val === "number") this.page = val;
        }
      },
    },
  },
  methods: {
    loadMore() {
      this.$emit("loading", this.page++);
    },
  },
};
</script>
